import classNames from 'classnames';
import styles from './ContentCard.module.scss';
import { HeadingProps, UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_LinkButton } from 'ui/components/1-atoms/Action/LinkButton/LinkButton';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import { UI_LinkWithIcon } from 'ui/components/1-atoms/Action/LinkWithIcon/LinkWithIcon';
import IconArrow from 'ui/icons/icon_right_arrow.svg';

export interface ContentCardProps {
	className?: string;
	image?: {
		url: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
	};
	link?: {
		url: string;
		name?: string;
		target?: string;
	};
	kicker?: string;
	altText?: string;
	heading?: string;
	headingStyle?: HeadingProps['style'];
	text?: string;
	displayLinkAs?: 'button' | 'arrowLink';
	orientation: 'Vertical' | 'Horizontal' | 'Horizontal Reverse' | '';
	imageCropping?: 'cover' | 'contain';
	imageAspectRatio?: 'Wide' | 'Square';
	padding?: 'Slim';
}

export const UI_ContentCard = ({
	className,
	image,
	link,
	kicker,
	altText,
	heading,
	headingStyle = 'md',
	text,
	displayLinkAs,
	orientation,
	imageCropping = 'cover',
	imageAspectRatio = 'Wide',
	padding,
}: ContentCardProps) => {
	// TODO: This needs some refactoring
	const contentInner = (
		<>
			{image && (
				<div className={classNames(styles.ContentCard_media, styles[`ContentCard_media___aspect${imageAspectRatio}`])}>
					<span className={styles.ContentCard_mediabox}>
						<UI_Picture
							imageRatio={0.5625}
							url={image.url}
							altText={altText}
							focalPoint={image.focalPoint}
							sizes="(max-width: 600px) 434px, 601px"
							imageCropping={imageCropping}
						/>
					</span>
				</div>
			)}
			<div className={classNames(styles.ContentCard_textbox, { [styles.ContentCard_textbox___noImage]: !image })}>
				{kicker && <div className={styles.ContentCard_kicker}>{kicker}</div>}
				{heading && (
					<UI_Heading className={styles.ContentCard_heading} headingLevel="h3" style={orientation != 'Vertical' ? 'lg75' : headingStyle}>
						{heading}
					</UI_Heading>
				)}
				{text?.length && <UI_RichText className={styles.ContentCard_text} content={text} />}
				{displayLinkAs == 'button' && link && link.url && (
					<UI_LinkButton {...link} className={styles.ContentCard_button} style="cta">
						{link.name}
					</UI_LinkButton>
				)}
				{displayLinkAs == 'arrowLink' && link && link.url && (
					<UI_LinkWithIcon
						className={styles.ContentCard_arrowLink}
						url={link.url}
						target={link.target}
						icon={
							<span className={styles.ContentCard_arrowLinkIcon}>
								<IconArrow />
							</span>
						}
						text={link.name}
					/>
				)}
			</div>
		</>
	);

	let content;

	if (link && link.url && !displayLinkAs) {
		content = (
			<UI_Link
				className={classNames(
					styles.ContentCard,
					{ [styles.ContentCard___row]: orientation === 'Horizontal' },
					{ [styles.ContentCard___rowReverse]: orientation === 'Horizontal Reverse' },
					{ [styles.ContentCard___rowNoImage]: orientation === 'Horizontal' && !image },
					{ [styles.ContentCard___rowReverseNoImage]: orientation === 'Horizontal Reverse' && !image },
					styles.ContentCard___link,
					className,
				)}
				title={link.name}
				{...link}
			>
				{contentInner}
			</UI_Link>
		);
	} else {
		content = (
			<div
				className={classNames(
					styles.ContentCard,
					{ [styles.ContentCard___row]: orientation === 'Horizontal' },
					{ [styles.ContentCard___rowReverse]: orientation === 'Horizontal Reverse' },
					{ [styles.ContentCard___rowNoImage]: orientation === 'Horizontal' && !image },
					{ [styles.ContentCard___rowReverseNoImage]: orientation === 'Horizontal Reverse' && !image },
					styles[`ContentCard___padding${padding}`],
					className,
				)}
			>
				{contentInner}
			</div>
		);
	}

	return content;
};
